import { Suspense } from 'react';

import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';
import { DYNAMIC_REMOTES } from '~/config/app.constants';

import withAdminAccess from '../Profile/components/MenuItem/withAdminAccess';
import PollingHandlers from '../PollingHandlers';

type RemoteModalsProps = {
  email: string;
  user: any;
  company: any;
};

const AnnouncementRemote = withAdminAccess(() => (
  <Suspense fallback={<span />}>
    <LoadRemote remote={DYNAMIC_REMOTES.ANNOUNCEMENT} loader={<span />}>
      {remoteModule => <PollingHandlers remoteModule={remoteModule} />}
    </LoadRemote>
  </Suspense>
));

const RemoteModals = ({ email, user, company }: RemoteModalsProps) => (
  <>
    <Suspense fallback={<span />}>
      <LoadRemote remote={DYNAMIC_REMOTES.CHOOSE_LEARNING_SITE} loader={<span />} />
    </Suspense>
    <AnnouncementRemote user={user} company={company} />
    <Suspense fallback={<span />}>
      <LoadRemote remote={DYNAMIC_REMOTES.GET_SUPPORT} loader={<span />} email={email} />
    </Suspense>
  </>
);

export default RemoteModals;
